const BASE_API = process.env.MIX_ENDLESS_API_URL

const state ={
	programs:[],
}
const getters = {
	programsGetter:({programs}) => programs,
}

const mutations = {
	setPrograms : (state,payload) => state.programs = payload,
}

const actions = {
	async getPrograms({commit},payload){
		await this.$axios.get(`${BASE_API}/agency/get-programs`,{params:{...payload.params},headers:{...payload.headers}}).then(res => {
			commit('setPrograms',res.data.result.data)
		})
	},
}

export default {namespaced:true,state,getters,mutations,actions}
